import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
import AuthService from '@/services/auth';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const authService = new AuthService();

const routes = [
    {
        path: '/',
        name: 'Home',
        title: 'Van Roy',
        alias: '/home',
        component: Home,
    },
    {
        path: '/about',
        name: 'About us',
        title: 'About us - Van Roy',
        component: () => import('../views/About.vue'),
    },
    {
        path: '/cars',
        name: 'Cars',
        title: 'Cars - Van Roy',
        component: () => import('../views/cars/Browser.vue'),
    },
    {
        path: '/login',
        name: 'Log in',
        title: 'Log in - Van Roy',
        component: () => import('../views/auth/Login.vue'),
    },
    {
        path: '/forgot-password',
        name: 'Password reset request',
        title: 'Password reset request - Van Roy',
        component: () => import('../views/auth/ForgotPassword.vue'),
    },
    {
        path: '/password-reset/:token',
        name: 'Password reset',
        title: 'Password reset - Van Roy',
        component: () => import('../views/auth/PasswordReset.vue'),
    },
    {
        path: '/register',
        name: 'Register',
        title: 'Register - Van Roy',
        component: () => import('../views/auth/Register.vue'),
    },
    {
        path: '/terms-and-conditions',
        name: 'Terms and Conditions',
        title: 'Terms and Conditions - Van Roy',
        component: () => import('../views/legal/TermsAndConditions.vue'),
    },
    {
        path: '/privacy-policy',
        name: 'Privacy Policy',
        title: 'Privacy Policy - Van Roy',
        component: () => import('../views/legal/PrivacyPolicy.vue'),
    },
    {
        path: '/user/profile',
        name: 'Own profile',
        title: 'Own profile - Van Roy',
        component: () => import('../views/user/Profile.vue'),
    },
    {
        path: '/user/profile/edit',
        name: 'Edit profile',
        title: 'Edit profile - Van Roy',
        component: () => import('../views/user/EditProfile.vue'),
    },
    {
        path: '/user/purchases',
        name: 'Purchases',
        title: 'My Purchases - Van Roy',
        component: () => import('../views/user/Purchases.vue'),
    },
    {
        path: '/user/bids',
        name: 'Bids',
        title: 'Bids - Van Roy',
        component: () => import('../views/user/Bids.vue'),
    },
    {
        path: '/manage',
        name: 'Manage',
        title: 'Manage - Van Roy',
        redirect: '/manage/cars',
    },
    {
        path: '/manage/dashboard',
        name: 'Dashboard',
        component: () => import('../views/manage/Dashboard.vue'),
    },
    {
        path: '/manage/users',
        name: 'Users management',
        component: () => import('../views/manage/Users.vue'),
    },
    {
        path: '/manage/users/:uuid',
        name: 'Manage user',
        component: () => import('../views/manage/User.vue'),
    },
    {
        path: '/manage/cars',
        name: 'Cars management',
        component: () => import('../views/manage/Cars.vue'),
    },
    {
        path: '/manage/cars/:uuid',
        name: 'Car management',
        component: () => import('../views/manage/Car.vue'),
    },
    {
        path: '/manage/bids',
        name: 'Bids management',
        component: () => import('../views/manage/Bids.vue'),
    },
    {
        path: '/manage/purchases',
        name: 'Purchases management',
        component: () => import('../views/manage/Purchases.vue'),
    },
    {
        path: '/manage/settings',
        name: 'Settings',
        component: () => import('../views/manage/Settings.vue'),
    },
    {
        path: '/manage/settings/:property',
        name: 'Settings property',
        component: () => import('../views/manage/Settings.vue'),
    },
    {
        path: '/manage/mail-settings',
        name: 'Mail Settings',
        component: () => import('../views/manage/MailSettings.vue'),
    },
    {
        path: '/car/:uuid',
        name: 'Car details',
        title: 'Car details - Van Roy',
        component: () => import('../views/cars/Details.vue'),
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.afterEach((to: Route, from: Route) => {
    window.scrollTo(0, 0);
});

export default router;
